import { Column } from 'react-table';

const JobTitleTableColumnConfig: Column[] = [
    {
        Header: 'Id',
        accessor: 'id',
    },
    {
        Header: 'Name',
        accessor: 'name',
    },
];

export default JobTitleTableColumnConfig;

export const DefaultVisibleJobTitleColumns = ['id', 'name'];

export const SearchableJobTitleTableColumnConfig = ['id', 'name'];
